import { Territory } from '../_classes/list/territory';

export let Territories: Territory[] = [
  {
    id: 1,
    territory_id: null,
    territory: null,
    name: 'Челябинск'
  },
  {
    id: 2,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Калининский район'
  },
  {
    id: 3,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Курчатовский район'
  },
  {
    id: 4,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Ленинский район'
  },
  {
    id: 5,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Металлургический район'
  },
  {
    id: 6,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Советский район'
  },
  {
    id: 7,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Тракторозаводский район'
  },
  {
    id: 8,
    territory_id: 1,
    territory: 'Челябинск',
    name: 'Челябинск, Центральный район'
  },
]



// WEBPACK FOOTER //
// /usr/home/rob/Staxi/client/src/app/_mock/territories.ts